import { useLocale } from '../i18n/LocaleContext'
import SEOHead from '../components/SEOHead'

// "Livrare" — mandatory for RO card-payment merchant verification (Netopia):
// the site must state both how and in what timeframe the services sold online
// are delivered. Everything here ships by email; nothing physical is shipped.
export default function Delivery() {
  const { t } = useLocale()

  return (
    <section className="section-padding bg-white">
      <SEOHead title={t.delivery.metaTitle} description={t.delivery.metaDescription} />
      <div className="container-max max-w-3xl">
        <h1 className="mb-2">{t.delivery.title}</h1>
        <p className="text-text-muted text-sm mb-8">{t.delivery.lastUpdated}</p>

        <div className="space-y-8">
          {t.delivery.content.map((section, i) => (
            <div key={i}>
              <h2 className="text-xl font-heading font-medium mb-3">{section.heading}</h2>
              <div className="text-text-secondary leading-relaxed whitespace-pre-line">
                {section.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
